module.exports = __webpack_public_path__ + "images/b532a8f26836974ae13a458677a3f1c5.svg";